import React from 'react';
import { motion } from 'framer-motion';

const PageTransition = ({ children, className, duration = 0.25 }) => {
    return (
        <motion.main
            className={className}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration }}
        >
            {children}
        </motion.main>
    );
};

export default PageTransition;
